import { render, staticRenderFns } from "./ListDigi.vue?vue&type=template&id=6b73a87f&scoped=true&"
import script from "./ListDigi.vue?vue&type=script&lang=js&"
export * from "./ListDigi.vue?vue&type=script&lang=js&"
import style0 from "./ListDigi.vue?vue&type=style&index=0&id=6b73a87f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b73a87f",
  null
  
)

export default component.exports